import { initializeCarousel } from './components/glideInit';

const defaults = {
    type: 'carousel',
    gap: 0,
    animationDuration: 1000
};

$(document).ready(function () {
    $('.js-editorial-hero-carousel').each(function () {
        const slides = this.getElementsByClassName('glide__slide');
        if (slides.length > 1) {
            initializeCarousel(this, defaults);            
        }
    });
});
